import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/Home';
import Login from '../pages/Login';
import ProtectedRoute from './ProtectedRoute';
import Header from '../components/Header';
import CargoInfo from '../pages/CargoInfo';
import CargoListView from '../pages/CargoInfo/views/ListView';
import CargoCreateView from '../pages/CargoInfo/views/CreateView';
import StepTwoView from '../pages/CargoInfo/views/StepTwoView';
import Release from '../pages/Release';
import ReleaseListView from '../pages/Release/views/ListView';
import ReleaseCreateView from '../pages/CargoInfo/views/CreateView';
import ReleasedListView from '../pages/Released/views/ListView';
import CargoSearchList from '../pages/CargoSearchList';
import CargoSearchListView from '../pages/CargoSearchList/views/ListView';
import CargoSearchListCreateView from '../pages/CargoSearchList/views/CreateView';
import ViewCargoSearchListById from '../pages/CargoSearchList/views/ViewById';
import CargoDocumentType from '../pages/CargoDocumentType';
import CargoDocumentTypeView from '../pages/CargoDocumentType/views/ListView';
import CargoDocumentTypeCreateView from '../pages/CargoDocumentType/views/CreateView';
import ViewCargoDocumentTypeById from '../pages/CargoDocumentType/views/ViewById';
import { useAuth } from '../apis/auth/AuthProvider';
import ToReleaseCreateView from '../pages/ToRelease/views/CreateView';
import Report from '../pages/Report';
import ReportListView from '../pages/Report/views/ListView';
import { useTranslation } from 'react-i18next';
import { ViewCargoById } from '../pages/CargoInfo/views/ViewCargoById';
import WarehouseClient from '../pages/WarehouseClient';
import WarehouseClientView from '../pages/WarehouseClient/views/ListView';
import WarehouseClientCreateView from '../pages/WarehouseClient/views/CreateView';
import ViewWarehouseClientById from '../pages/WarehouseClient/views/ViewById';
import CargoEditView from '../pages/CargoInfo/views/EditView';
import StepTwoEditView from '../pages/CargoInfo/views/StepTwoEditView';
import WarehouseUserClientReportDaily from '../pages/WarehouseUserClientReportDaily';
import WarehouseUserClientReportDailyView from '../pages/WarehouseUserClientReportDaily/views/ListView';
import WarehouseUserClientReportDailyCreateView from '../pages/WarehouseUserClientReportDaily/views/CreateView';
import ViewWarehouseUserClientReportDailyById from '../pages/WarehouseUserClientReportDaily/views/ViewById';
import User from '../pages/User';
import UserView from '../pages/User/views/ListView';
import UserCreateView from '../pages/User/views/CreateView';
import ViewUserById from '../pages/User/views/ViewById';
import Destination from '../pages/Destination';
import DestinationView from '../pages/Destination/views/ListView';
import Client from '../pages/Client';
import ClientView from '../pages/Client/views/ListView';
import ViewClientById from '../pages/Client/views/ViewById';
import ClientCreateView from '../pages/Client/views/CreateView';
import Supplier from '../pages/Supplier';
import SupplierView from '../pages/Supplier/views/ListView';
import SupplierCreateView from '../pages/Supplier/views/CreateView';
import ViewSupplierById from '../pages/Supplier/views/ViewById';
import BranchView from '../pages/Branch/views/ListView';
import BranchCreateView from '../pages/Branch/views/CreateView';
import ViewBranchById from '../pages/Branch/views/ViewById';
import Warehouse from '../pages/Warehouse';
import WarehouseView from '../pages/Warehouse/views/ListView';
import WarehouseCreateView from '../pages/Warehouse/views/CreateView';
import ViewWarehouseById from '../pages/Warehouse/views/ViewById';
import DestinationCreateView from '../pages/Destination/views/CreateView';
import ViewDestinationById from '../pages/Destination/views/ViewById';
import ViewReleaedById from '../pages/Released/views/ViewById';
import ShipInfoListView from '../pages/ShipInfo/views/ListView';
import ShipInfoViewyId from '../pages/ShipInfo/views/ViewById';
import ListShippedView from '../pages/ShipInfo/views/ListShippedView';

function AppRoutes() {
  const { isAuthenticated } = useAuth();
  const { i18n } = useTranslation();
  const location = useLocation();
  const noHeaderRoutes = ['/login', '/404'];

  return (
    <>
      {/* Renderiza o Header apenas fora do login e 404 */}
      {!noHeaderRoutes.includes(location.pathname) && <Header />}

      {/* Força a re-renderização da aplicação quando o idioma mudar */}
      <div key={i18n.language}>
        {' '}
        {/* A chave aqui é o idioma atual */}
        <Routes>
          {/* Rotas públicas */}
          <Route path="/login" element={<Login />} />

          {/* Rotas protegidas */}
          <Route
            path="/"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Home />
              </ProtectedRoute>
            }
          />

          <Route
            path="/cargo-info/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CargoInfo />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<CargoListView />} />
            <Route path="create" element={<CargoCreateView />} />
            <Route path="cargo/:id" element={<ViewCargoById />} />
            <Route path="cargo/delete/:id" element={<ViewCargoById />} />
            <Route path="create/step-two" element={<StepTwoView />} />
            <Route path="cargo/:id/edit" element={<CargoEditView />} />
            <Route
              path="cargo/:id/edit/step-two"
              element={<StepTwoEditView />}
            />
          </Route>

          <Route
            path="/release/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Release />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<ReleaseListView />} />
            <Route path="create" element={<ReleaseCreateView />} />
            <Route path="to-release" element={<ToReleaseCreateView />} />
            <Route path="released" element={<ReleasedListView />} />
            <Route path="released/:id" element={<ViewReleaedById />} />
          </Route>

          <Route
            path="/cargoSearchList/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CargoSearchList />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<CargoSearchListView />} />
            <Route path="create" element={<CargoSearchListCreateView />} />
            <Route path=":id" element={<ViewCargoSearchListById />} />
          </Route>

          <Route
            path="/cargoDocumentType/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <CargoDocumentType />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<CargoDocumentTypeView />} />
            <Route path="create" element={<CargoDocumentTypeCreateView />} />
            <Route path=":id" element={<ViewCargoDocumentTypeById />} />
          </Route>

          <Route
            path="/destination/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Destination />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<DestinationView />} />
            <Route path="create" element={<DestinationCreateView />} />   
            <Route path=":id" element={<ViewDestinationById />} />
          </Route>

          <Route
            path="/user/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <User />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<UserView />} />
            
            <Route path="create" element={<UserCreateView />} />   
            <Route path=":id" element={<ViewUserById />} />
          </Route>

          <Route
            path="/warehouse/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Warehouse />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<WarehouseView />} />
            <Route path="create" element={<WarehouseCreateView />} />
            <Route path=":id" element={<ViewWarehouseById />} />
          </Route>

          <Route
            path="/warehouseClient/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <WarehouseClient />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<WarehouseClientView />} />
            <Route path="create" element={<WarehouseClientCreateView />} />
            <Route path=":id" element={<ViewWarehouseClientById />} />
          </Route>

          <Route
            path="/warehouseUserClientReportDaily/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <WarehouseUserClientReportDaily />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<WarehouseUserClientReportDailyView />} />
            <Route path="create" element={<WarehouseUserClientReportDailyCreateView />} />
            <Route path=":id" element={<ViewWarehouseUserClientReportDailyById />} />
          </Route>

          <Route
            path="/report"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Report />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<ReportListView />} />
          </Route>

          {/* Rota de fallback para páginas não encontradas */}
          <Route
            path="*"
            element={
              isAuthenticated ? <NotFound /> : <Navigate to="/login" replace />
            }
          />
          
          <Route
            path="/client/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Client />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<ClientView />} />
            <Route path="create" element={<ClientCreateView />} />   
            <Route path=":id" element={<ViewClientById />} />
          </Route>
          
          <Route
            path="/supplier/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Supplier />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<SupplierView />} />
            <Route path="create" element={<SupplierCreateView />} />   
            <Route path=":id" element={<ViewSupplierById />} />
          </Route>
          
          <Route
            path="/branch/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Supplier />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<BranchView />} />
            <Route path="create" element={<BranchCreateView />} />   
            <Route path=":id" element={<ViewBranchById />} />
          </Route>

          <Route
            path="/shipinfo/*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                <Supplier />
              </ProtectedRoute>
            }
          >
            <Route path="" element={<ShipInfoListView />} />
            <Route path="shipped" element={<ListShippedView />} />
            <Route path=":id" element={<ShipInfoViewyId />} />
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default AppRoutes;
